import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService} from './auth.service';

type GroupType = Array<{id: string, title: string, state: number, orderNumber: number, contacts: ContactType}>;
type ContactType = Array<{id: string, name: string, surname: string, nick: string, state: number}>;

@Injectable()
export class ContactsService {
  isLoaded: boolean = false;
  isActual: boolean = false;
  isSmallDevice: boolean = true;

  contacts: GroupType;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };
  constructor(private http: HttpClient, private authService: AuthService) {
    if(window.screen.width > 1200) this.isSmallDevice = false; 
   }

  getContacts(): GroupType {
    this.authService.notify = "";
    let params = {
      "idUser": localStorage.getItem("idUser")
    }

    this.http.post(this.authService.databaseURL+'getdata.php?table=contactgroup', params, this.httpOptions).subscribe(
      (data:any[]) => {
        this.contacts = data;
        this.isActual = true;
        this.isLoaded = true;
      },
      error => this.isActual = false
    )
    
    return this.contacts;
  }

  addGroup(title){
    this.authService.notify = "";
    let group = {
      "id": "G" + Date.now() + "-" + localStorage.getItem("idUser").slice(-10),
      "title": title,
      "orderNumber": (this.contacts.length+1),
      "idUser": localStorage.getItem("idUser"),
      "state": 0
    }

    let offGroup = {
      "id": group.id,
      "title": title,
      "state": 0,
      "orderNumber": (this.contacts.length+1),
      "contacts": []
    }

    this.http.post(this.authService.databaseURL+'adddata.php?table=contactgroup', group, this.httpOptions).subscribe(
      (data:any[]) => {
        this.contacts.push(offGroup);
      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
    
  }

  addContact(i, contactInfo){
    this.authService.notify = "";
    let contact = {
      "id": "c" + Date.now() + "-" + localStorage.getItem("idUser").slice(-10),
      "name": contactInfo.name,
      "surname": contactInfo.surname,
      "nick": "",
      "idUser": localStorage.getItem("idUser"),
      "state": 0,
      "idGroup": contactInfo.idGroup
    }

    let offContact = {
      "id": contact.id,
      "name": contactInfo.name,
      "surname": contactInfo.surname,
      "nick": "",
      "state": 0
    }

    this.http.post(this.authService.databaseURL+'adddata.php?table=contact', contact, this.httpOptions).subscribe(
      (data:any[]) => {
        this.contacts[i].contacts.push(offContact);
      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
    
  }

  updateGroup(editedGroup,editedGroupID){ 
    this.authService.notify = "";
    this.http.post(this.authService.databaseURL+'updatedata.php?table=group', editedGroup, this.httpOptions).subscribe(
      (data:any[]) => {
        this.contacts[editedGroupID].title = editedGroup.title;
      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }

  removeGroup(i, id){
    this.authService.notify = "";
    
    let group = {
      "id": id,
      "idUser": localStorage.getItem("idUser"),
      "orderNumber": this.contacts[i].orderNumber
    }
    
    this.http.post(this.authService.databaseURL+'deletedata.php?table=group', group, this.httpOptions).subscribe(
      (data:any[]) => {
        for(let x = i; x < this.contacts.length; x++){
          this.contacts[x].orderNumber--;
        }
        this.contacts.splice(i,1);
      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }

  changeOrder(newOrderNumber){
    this.authService.notify = "";
    if(this.isActual == false) return;

    let shiftDown = true;
    let shiftedItem = newOrderNumber;
    for(let i = 0; i < this.contacts.length; i++){
      if((i+1) == this.contacts[i].orderNumber){
        
      }
      else{
        shiftedItem = i + 1;
        if(this.contacts[i].orderNumber > newOrderNumber) {
          shiftedItem = this.contacts[i].orderNumber;
          shiftDown = false;
        }
        break;
      }
    }
    if(shiftDown == newOrderNumber){

    }
    else if(shiftDown == true){
      for(let i = shiftedItem-1; i < newOrderNumber; i++){
        this.contacts[i].orderNumber--;
      }
      this.contacts[newOrderNumber-1].orderNumber = newOrderNumber;

      let groupsInfo = {
        "fromList":  shiftedItem,
        "toList": newOrderNumber,
        "orderItemID": this.contacts[newOrderNumber-1].id,
        "idUser": localStorage.getItem("idUser"),
      }

      this.http.post(this.authService.databaseURL+'updatedata.php?table=grouporderdown', groupsInfo, this.httpOptions).subscribe(
        (data:any[]) => {

        },
        error => {
          this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
          this.isActual = false;
        }
      );

    }
    else{
      for(let i = newOrderNumber-1; i < shiftedItem; i++){
        this.contacts[i].orderNumber++;
      }
      this.contacts[newOrderNumber-1].orderNumber = newOrderNumber;
      
      let groupsInfo = {
        "fromList":  shiftedItem,
        "toList": newOrderNumber,
        "orderItemID": this.contacts[newOrderNumber-1].id,
        "idUser": localStorage.getItem("idUser"),
      }

      this.http.post(this.authService.databaseURL+'updatedata.php?table=grouporderup', groupsInfo, this.httpOptions).subscribe(
        (data:any[]) => {

        },
        error => {
          this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
          this.isActual = false;
        }
      );

    }
  }

  orderUp(i){
    let orderInfo = {
      "thisItemID":  this.contacts[i].id,
      "nextItemID": this.contacts[i-1].id,
      "thisItemOrder":  this.contacts[i].orderNumber,
      "nextItemOrder": this.contacts[i-1].orderNumber,
      "idUser": localStorage.getItem("idUser")
    }

    let swapArray = this.contacts[i]; 
    this.contacts[i] = this.contacts[i-1];
    this.contacts[i-1] = swapArray;

    let swapOrderNumber = this.contacts[i].orderNumber;
    this.contacts[i].orderNumber = this.contacts[i-1].orderNumber;
    this.contacts[i-1].orderNumber = swapOrderNumber;
    
    this.http.post(this.authService.databaseURL+'updatedata.php?table=grouporder', orderInfo, this.httpOptions).subscribe(
      (data:any[]) => {

      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }
  orderDown(i){
    let orderInfo = {
      "thisItemID":  this.contacts[i].id,
      "nextItemID": this.contacts[i+1].id,
      "thisItemOrder":  this.contacts[i].orderNumber,
      "nextItemOrder": this.contacts[i+1].orderNumber,
      "idUser": localStorage.getItem("idUser")
    }

    let swapArray = this.contacts[i]; 
    this.contacts[i] = this.contacts[i+1];
    this.contacts[i+1] = swapArray;

    let swapOrderNumber = this.contacts[i].orderNumber;
    this.contacts[i].orderNumber = this.contacts[i+1].orderNumber;
    this.contacts[i+1].orderNumber = swapOrderNumber;
    
    this.http.post(this.authService.databaseURL+'updatedata.php?table=grouporder', orderInfo, this.httpOptions).subscribe(
      (data:any[]) => {

      },
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/contacts.service.ts